export interface MotionSample {
  x: number;
  y: number;
  time: number;
}

export interface Velocity {
  x: number;
  y: number;
}

export function clamp(value: number, minimum: number, maximum: number): number {
  return Math.min(maximum, Math.max(minimum, value));
}

export function calculateThrowVelocity(
  samples: readonly MotionSample[],
  maxSpeed: number,
  windowMs = 110,
): Velocity {
  if (samples.length < 2) return { x: 0, y: 0 };

  const newest = samples.at(-1);
  if (!newest) return { x: 0, y: 0 };

  let oldest = samples[0];
  for (let index = samples.length - 2; index >= 0; index -= 1) {
    const candidate = samples[index];
    if (!candidate) continue;
    oldest = candidate;
    if (newest.time - candidate.time >= windowMs) break;
  }

  if (!oldest) return { x: 0, y: 0 };
  const elapsedSeconds = Math.max((newest.time - oldest.time) / 1000, 1 / 240);
  let x = (newest.x - oldest.x) / elapsedSeconds;
  let y = (newest.y - oldest.y) / elapsedSeconds;
  const speed = Math.hypot(x, y);

  if (speed > maxSpeed) {
    const scale = maxSpeed / speed;
    x *= scale;
    y *= scale;
  }

  return { x, y };
}
